import { Component, Input, Output, EventEmitter, HostListener, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { JsonService, LoggerService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-institution-form-pending',
  templateUrl: './institution-form-pending.component.html',
  styleUrls: ['./institution-form-pending.component.scss', '../../detalhe/detalhe.component.scss']
})
export class InstitutionFormPendingComponent implements OnInit, OnChanges {
  @Input() instituicaoForm!: FormGroup;
  @Input() nomeInstituicaoFiltrado: any[] = [];
  @Input() cnesFiltrado: any[] = [];
  @Input() isSmartCase!: boolean;
  @Input() isVisibleEnderecoinstituicao!: boolean;
  @Input() codigoPaisMaestro: string = '';
  @Input() mostrarPendencias: boolean = false;

  // Novas entradas/variáveis para o layout de retorno e status
  public instituicaoSelecionada: any = null;
  public isSearchModalOpen = false;
  public institutionSearchResults: any[] = [];
  public pesquisaInstituicao: string = '';
  public listaInstituicoesFiltrada: any[] = [];
  public listaInstituicoesCompleta: any[] = [];
  public instituicaoSelecionadaCombobox: string = '';
  private focusComboOnLoad: boolean = false;
  private isBuscandoInstituicoes: boolean = false;
  private ultimoTermoBuscaInstituicaoApi: string = '';
  private termoBuscaInstituicaoPendente: string = '';
  public instituicaoSelecionadaNome: string = '';
  public isInstituicaoVerificadaChecked: boolean = false;
  public isInstituicaoInsercaoManualAtiva: boolean = false;

  @ViewChild('retornoNomeInput') retornoNomeInput?: ElementRef;

  @Output() validarEntrada = new EventEmitter<void>();
  @Output() isValidatedChange = new EventEmitter<boolean>();

  getInstStatus(): string {
    const validInst = !!this.instituicaoForm.get('validInst')?.value;
    const filter = this.instituicaoForm.get('ConteudoInstFiltro')?.value || [];
    const count = filter.length;

    if (validInst) return 'Válido';
    if (count > 0) return 'Ambíguo';
    return 'Inválido';
  }

  getInstStatusClass(): string {
    const status = this.getInstStatus();

    switch (status) {
      case 'Ambíguo': return 'ambiguous';
      case 'Válido': return 'valid';
      case 'Inválido': return 'not-found';
      default: return '';
    }
  }

  isAmbiguous(): boolean {
    return this.getInstStatus() === 'Ambíguo';
  }
  isValid(): boolean {
    return this.getInstStatus() === 'Válido';
  }
  isNotFound(): boolean {
    return this.getInstStatus() === 'Inválido';
  }

  onInstituicaoValidadoChange(event: any): void {
    this.isInstituicaoVerificadaChecked = event.target.checked;
    if (event.target.checked) {
      this.setInteraction('marcado checkbox não encontrado.');
    }
    this.atualizarValidacao();
  }

  setInteraction(interaction: string): void {
    if (this.instituicaoForm && this.instituicaoForm.get('interaccion_del_usuario')?.value !== interaction) {
      this.instituicaoForm.get('interaccion_del_usuario')?.setValue(interaction, { emitEvent: false });
    }
  }

  public campoValido: boolean = false;

  atualizarValidacao(): void {
    const retornoNome = this.instituicaoForm?.get('retorno_nome')?.value;
    const isInformado = typeof retornoNome === 'string' ? retornoNome.trim() !== '' : !!retornoNome;
    this.campoValido = this.isValid() || isInformado || this.isInstituicaoVerificadaChecked;
    this.isValidatedChange.emit(this.campoValido);
  }

  // Getters reativos para verificar o status diretamente dos valores no FormGroup passado pelo pai
  // get instituicaoStatus(): string {
  //   const valid = this.instituicaoForm?.get('validInst')?.value;
  //   const validStr = String(valid).toLowerCase();
    
  //   if (valid === true || validStr === 'true' || validStr === '1' || validStr === 'valid' || validStr === 'v') {
  //     return 'Valid';
  //   }
    
  //   const conteudo = this.ConteudoInst;
  //   if (conteudo && conteudo.length > 1) {
  //     return 'Ambigos';
  //   }
    
  //   return 'Invalid';
  // }

  get ConteudoInst(): any[] {
    let conteudo = this.instituicaoForm?.get('ConteudoInstFiltro')?.value;
    if (typeof conteudo === 'string') {
      try {
        conteudo = JSON.parse(conteudo);
      } catch (e) {
        return [];
      }
    }
    return Array.isArray(conteudo) ? conteudo : [];
  }

  constructor(
    private jsonService: JsonService,
    private logger: LoggerService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    setTimeout(() => this.atualizarValidacao(), 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['instituicaoForm'] && !changes['instituicaoForm'].firstChange) {
      this.isInstituicaoVerificadaChecked = false;
      this.isInstituicaoInsercaoManualAtiva = false;
      setTimeout(() => this.atualizarValidacao(), 0);
    }
  }

  // Getters para FormArray
  get telefoneArray(): FormArray {
    return this.instituicaoForm.get('telefone') as FormArray;
  }

  // Método para capturar a seleção da instituição e atualizar os dados da tela/formulário
  onInstitutionSelect(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const index = target.value;

    if (index && index !== '') {
      this.instituicaoSelecionada = this.ConteudoInst[Number(index)];

      this.instituicaoForm.patchValue({
        nomeInstituicao: this.instituicaoSelecionada.nombre_institucion || '',
        cdgCiudad: this.instituicaoSelecionada.cdg_ciudad || '',
        rua: this.instituicaoSelecionada.direccion || '',
        localidade: this.instituicaoSelecionada.localidad || '',
        codigoPostal: this.instituicaoSelecionada.cp || '',
        nro_instit: this.instituicaoSelecionada.nro_instit || '',
        retorno_nome: this.instituicaoSelecionada.nombre_institucion || '',
        retorno_rua: this.instituicaoSelecionada.direccion || '',
        retorno_cidade: this.instituicaoSelecionada.localidad || '',
        retorno_cep: this.instituicaoSelecionada.cp || '',
        retorno_cdg_cidade: this.instituicaoSelecionada.cdg_ciudad || '',
        retorno_nro_instit: this.instituicaoSelecionada.nro_instit || ''
      });
      this.setInteraction('Item selecionado da ambiguidade');
    } else {
      this.instituicaoSelecionada = null;
    }
    this.atualizarValidacao();
  }

  onRetornoNomeInput(): void {
    this.setInteraction('Item informado pelo usuário');
    this.atualizarValidacao();
  }

  ativarEntradaManualInstituicao(): void {
    this.isInstituicaoInsercaoManualAtiva = true;
    setTimeout(() => this.retornoNomeInput?.nativeElement?.focus(), 0);
  }

  // Métodos adicionar/remover
  addTelefone() {
    if (this.telefoneArray.length < 2) {
      this.telefoneArray.push(new FormControl(''));
    }
  }

  removeTelefone(index: number) {
    if (this.telefoneArray.length > 0) {
      this.telefoneArray.removeAt(index);
    }
  }

  abrirModalInstituicao(): void {
    this.isSearchModalOpen = true;
    this.pesquisaInstituicao = '';
    this.instituicaoSelecionadaCombobox = '';
    this.instituicaoSelecionadaNome = this.instituicaoForm.get('nomeInstituicao')?.value || '';
    this.focusComboOnLoad = true;
    this.listaInstituicoesCompleta = [];
    this.isBuscandoInstituicoes = false;
    this.ultimoTermoBuscaInstituicaoApi = '';
    this.termoBuscaInstituicaoPendente = '';
    this.buscarInstituicoesApi();
  }

  abrirModalInstituicaoSpace(event: Event): void {
    const kbEvent = event as KeyboardEvent;
    if (kbEvent.shiftKey) {
      event.preventDefault();
      this.abrirModalInstituicao();
    }
  }

  fecharModalInstituicao(): void {
    this.isSearchModalOpen = false;
    this.pesquisaInstituicao = '';
    this.instituicaoSelecionadaCombobox = '';
    this.listaInstituicoesFiltrada = [];
    this.listaInstituicoesCompleta = [];
    this.isBuscandoInstituicoes = false;
    this.ultimoTermoBuscaInstituicaoApi = '';
    this.termoBuscaInstituicaoPendente = '';
  }

  buscarInstituicoesApi(termoBuscaParam?: string): void {
    const termoBusca = (termoBuscaParam || this.instituicaoSelecionadaNome || '').trim();

    if (!termoBusca) {
      this.listaInstituicoesCompleta = [];
      this.listaInstituicoesFiltrada = [];
      this.focusComboOnLoad = false;
      return;
    }

    if (this.ultimoTermoBuscaInstituicaoApi === termoBusca) {
      return;
    }

    if (this.isBuscandoInstituicoes) {
      this.termoBuscaInstituicaoPendente = termoBusca;
      return;
    }

    this.isBuscandoInstituicoes = true;
    this.ultimoTermoBuscaInstituicaoApi = termoBusca;

    const cidade = this.instituicaoForm.get('cdgCiudad')?.value || '1';
    const pais = this.codigoPaisMaestro || '';

    const body = {
      pais: pais,
      cidade: cidade,
      nome: termoBusca,
      quantidade: "30"
    };

    this.jsonService.findInstituicao(body).subscribe({
      next: (resp: any[]) => {
        if (termoBusca !== this.ultimoTermoBuscaInstituicaoApi) {
          return;
        }

        const itemNaoEncontrado = {
          instituicao: this.translate.instant('Instituição não encontrada na pesquisa.'),
          isNotFoundItem: true
        };

        this.listaInstituicoesCompleta = [itemNaoEncontrado, ...resp]
          .map((item, index) => ({ ...item, id: index }));

        this.filtrarInstituicoes();

        if (this.focusComboOnLoad) {
          this.focusComboOnLoad = false;
          setTimeout(() => {
            const selectElement = document.querySelector('.modal-body select') as HTMLSelectElement;
            if (selectElement) selectElement.focus();
          }, 100);
        }
      },
      error: (err: any) => {
        this.logger.error('Erro na busca de instituição por similaridade', err);
        this.listaInstituicoesCompleta = [];
        this.listaInstituicoesFiltrada = [];
        this.focusComboOnLoad = false;
        this.isBuscandoInstituicoes = false;
      },
      complete: () => {
        this.isBuscandoInstituicoes = false;
        if (this.termoBuscaInstituicaoPendente) {
          const proximoTermo = this.termoBuscaInstituicaoPendente;
          this.termoBuscaInstituicaoPendente = '';
          this.buscarInstituicoesApi(proximoTermo);
        }
      }
    });
  }

  private deveRefazerBuscaInstituicaoApi(termoBusca: string): boolean {
    if (!this.ultimoTermoBuscaInstituicaoApi || termoBusca === this.ultimoTermoBuscaInstituicaoApi) {
      return false;
    }

    const termoAtualLower = termoBusca.toLowerCase();
    const ultimoTermoLower = this.ultimoTermoBuscaInstituicaoApi.toLowerCase();
    const palavrasAtuais = termoAtualLower.split(/\s+/).filter(Boolean);
    const palavrasUltimaBusca = ultimoTermoLower.split(/\s+/).filter(Boolean);

    return palavrasAtuais.length > palavrasUltimaBusca.length && termoAtualLower.startsWith(ultimoTermoLower);
  }

  filtrarInstituicoes(): void {
    const termoBusca = (this.pesquisaInstituicao || '').trim();

    if (!termoBusca) {
      this.listaInstituicoesFiltrada = [...this.listaInstituicoesCompleta];
      return;
    }

    const termoLower = termoBusca.toLowerCase();
    this.listaInstituicoesFiltrada = this.listaInstituicoesCompleta.filter(inst =>
      inst.isNotFoundItem || ((inst.instituicao || '').toLowerCase().includes(termoLower))
    );

    if (this.listaInstituicoesFiltrada.length === 2 && this.listaInstituicoesFiltrada[0].isNotFoundItem) {
      this.instituicaoSelecionadaCombobox = this.listaInstituicoesFiltrada[1].id.toString();
      setTimeout(() => {
        const selectElement = document.querySelector('.modal-body select') as HTMLSelectElement;
        if (selectElement) {
          selectElement.focus();
        }
      }, 100);
    }

    const possuiInstituicaoNaLista = this.listaInstituicoesFiltrada.some(inst => !inst.isNotFoundItem);
    if (!possuiInstituicaoNaLista || this.deveRefazerBuscaInstituicaoApi(termoBusca)) {
      this.buscarInstituicoesApi(termoBusca);
    }
  }

  onInstituicaoClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName.toLowerCase() === 'option') {
      const option = target as HTMLOptionElement;
      this.instituicaoSelecionadaCombobox = option.value;
      this.confirmarSelecaoCombo(event);
    }
  }

  confirmarSelecaoCombo(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    if (this.instituicaoSelecionadaCombobox !== '' && this.instituicaoSelecionadaCombobox !== null) {
      const selectedIndex = parseInt(this.instituicaoSelecionadaCombobox as string, 10);
      const inst = this.listaInstituicoesFiltrada[selectedIndex];
      if (inst) {
        this.selectInstitutionFromSearch(inst);
      }
    }
  }

  openCombo(event: Event): void {
    const kbEvent = event as KeyboardEvent;
    let isArrowDown = false;
    let isShiftO = false;

    if (kbEvent && kbEvent.type === 'keydown') {
      isShiftO = kbEvent.shiftKey && (kbEvent.key === 'o' || kbEvent.key === 'O');
      isArrowDown = kbEvent.key === 'ArrowDown';

      if (!isShiftO && !isArrowDown) {
        return;
      }
    }

    const selectElement = document.querySelector('.modal-body select') as HTMLSelectElement;
    if (selectElement) {
      if (isShiftO || (isArrowDown && document.activeElement !== selectElement)) {
        event.preventDefault();
      }
      selectElement.focus();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleDocumentKeydown(event: KeyboardEvent): void {
    if (this.isSearchModalOpen && event.altKey && /^[0-9]$/.test(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      const num = parseInt(event.key, 10);
      const index = num;
      if (this.listaInstituicoesFiltrada && this.listaInstituicoesFiltrada[index]) {
        this.instituicaoSelecionadaCombobox = index.toString();
        this.confirmarSelecaoCombo(event);
      }
    }
  }

  selectInstitutionFromSearch(result: any) {
    const nomeFinal = result.isNotFoundItem
      ? (this.instituicaoForm.get('nomeInstituicao')?.value || '').trim()
      : result.instituicao;

    if (nomeFinal) {
      this.instituicaoForm.patchValue({
        retorno_nome: nomeFinal,
        retorno_nro_instit: result.isNotFoundItem ? '' : (result.nro_instit || '')
      });
    }
    this.isInstituicaoVerificadaChecked = result.isNotFoundItem === true;
    this.setInteraction(result.isNotFoundItem ? 'Item informado pelo usuário' : 'Item adicionado por pesquisa');
    this.atualizarValidacao();
    this.fecharModalInstituicao();
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    if (this.isSearchModalOpen) {
      this.fecharModalInstituicao();
    }
  }
}